import { createApp } from "vue";
import "./assets/css/index.css";
import "./assets/css/common.css";
import "./assets/css/sysicon.css";
import "./assets/css/color.css";

import App from "./App.vue";
import router from "./router";
import Tabbar from "@/components/phone/Tabbar.vue";
import Navbar from "@/components/phone/Navbar.vue";
import Vfm from "@/components/vfm/Vfm.vue";
import SecondHeader from "@/components/vfm/pc/SecondHeader.vue";
import Grid from "@/components/Grid.vue";
import PcVfm from "@/components/vfm/PcVfm.vue";
import PhoneFormInput from "@/components/phone/FormInput.vue";
import PasswordInput from "@/components/phone/PasswordInput.vue";
import PcFormInput from "@/components/pc/FormInput.vue";

import BS from "@/components/BS.vue";
import R$ from "@/components/R$.vue";

import pinia from "./stores";
import plugin from "./utils/plugin";

import { setToast, setErrorToast } from "./utils/util";

// 国际化
import { initConfig, createI18nInstance } from "./config";
// import VConsole from "vconsole";
// import "./utils/autoUpdate"; //检测自动更新
window.onerror = function (...args) {
    console.log("window.onerror", args);
};

window.onunhandledrejection = function (e) {
    console.log("Promise", e.reason);
};

const old = Element.prototype.setAttribute;

Element.prototype.setAttribute = function (name, value) {

    if (name === '"' || name === "'") {

        console.error("非法属性:", name);

        console.log({
            name,
            value,
            tag: this.tagName,
            html: this.outerHTML
        });

        console.trace();
        return;
    }

    try {
        return old.call(this, name, value);
    } catch (e) {
        console.error("setAttribute错误:", e.message, { name, value, tag: this.tagName });
        return;
    }
};

async function initApp() {
  const myConfig = await initConfig();
  const myI18n = await createI18nInstance();
  const app = createApp(App);
  app.config.globalProperties.$C = myConfig;
  app.use(myI18n);
  // console.log(myConfig);
  // new VConsole();
  app.component("Tabbar", Tabbar);
  app.component("Navbar", Navbar);
  app.component("Vfm", Vfm);
  app.component("BS", BS);
  app.component("SecondHeader", SecondHeader);
  app.component("Grid", Grid);
  app.component("PcVfm", PcVfm);
  app.component("R$", R$);
  app.component("PcFormInput", PcFormInput);
  app.component("PhoneFormInput", PhoneFormInput);
  app.component("PasswordInput", PasswordInput);
  app.use(pinia);
  app.use(router);
  app.use(plugin);
  setToast(app.config.globalProperties.$Toast);
  setErrorToast(app.config.globalProperties.$ErrorToast);
  app.mount("#app");

  // window.onerror = function (msg, url, line, col, error) {
  //   alert(msg + "\n" + url + ":" + line);
  // };
  //  window.onerror = function (msg, url, line, col, error) {
  //   // 生产环境不显示 alert 弹窗
  //   if (import.meta.env.MODE === 'development') {
  //     console.error('Script Error:', msg, url, line, col, error);
  //     // alert(msg + "\n" + url + ":" + line);
  //   }
  //   // 返回 true 阻止默认错误处理
  //   return true;
  // };
}

initApp();

export { router };
